const lunchIngredients = [
  "Knorr Thai Sweet Chilli Sauce",
  "Knorr Green Chutney",
  "Knorr Barbecue Sauce",
  "Knorr Chattpatta Noodles",
  "Knorr Chicken Noodles",
  "Knorr Spicy Beef Noodles",
  "Knorr Blazin' Hot Noodles",
  "Knorr Chicken Soup Stock",
  "Knorr Pulao Soup Stock",
  "Knorr Chicken Powder",
  "Knorr Chattpatta Masala",
  "Knorr Tomato Ketchup",
  "Knorr Chilli Garlic Sauce",
  "Knorr Pizza Pasta Sauce",
  "COLESLAW",
  "EGGPLANT",
  "BREAD",
  "DOUGH",
  "FISH",
  "CORIANDER",
  "POULTRY",
  "ALMOND",
  "ANCHOVY",
  "ARTICHOKE",
  "ASPARAGUS",
  "AVOCADO",
  "BABY CORN",
  "BABY GEM LETTUCE",
  "BABY POTATO",
  "BABY SPINACH",
  "BAGEL",
  "BARBECUE SAUCE",
  "BARLEY",
  "BASIL",
  "BAY LEAF",
  "BEANS",
  "CRUSHED CHILLI",
  "KASHMIRI CHILLI",
  "SALT",
  "BLACK PEPPER",
  "GINGER GARLIC PASTE",
  "CHEESE SLICE",
  "BEANSPROUTS",
  "BEEF",
  "BEEF LOIN",
  "BEEF TENDERLOIN",
  "BEEF STEAK",
  "BEET",
  "BEETROOT",
  "BELL PEPPER",
  "BLACK BEAN",
  "BOK CHOY",
  "BREAD CRUMB",
  "BRIE CHEESE",
  "BROCCOLI",
  "BUN",
  "BURGER BUN",
  "BUTTER",
  "BUTTON MUSHROOM",
  "CABBAGE",
  "CAESAR SALAD DRESSING",
  "CANNED BAKED BEANS",
  "CARROT",
  "CASHEW",
  "CAULIFLOWER",
  "CELERY",
  "CHEDDAR CHEESE",
  "CHEESE",
  "CHERRY TOMATOES",
  "CHESTNUT",
  "CHICKEN",
  "CHICKEN BREAST",
  "CHICKEN BROTH",
  "CHICKEN DRUMSTICK",
  "MOZZARELLA CHEESE",
  "SHREDDED CHEESE",
  "PIZZA SAUCE",
  "CHILLI GARLIC SAUCE",
  "GREEN CHUTNEY",
  "GREEN CHILLI",
  "CHILLI POWDER",
  "BAKING SODA",
  "BAKING POWDER",
  "FLOUR",
  "CORNFLOUR",
  "CORN FLOUR",
  "WATER",
  "CORNSTRACH",
  "SUGAR",
  "CHILLI SAUCE",
  "BALSAMIC VINEGAR",
  "CHAAT MASALA",
  "CHICKPEA FLOUR",
  "CARDAMOM",
  "CLOVE",
  "DRIED CORIANDER",
  "GREEN CARDAMOM",
  "BLACK CARDAMOM",
  "CINNAMON STICKS",
  "BLACK PEPPERCORNS",
  "DRIED FENUFREEK LEAVES",
  "TAMARIND",
  "CHICKEN MINCE",
  "BEEF MINCE",
  "MUTTON",
  "MUTTON MINCE",
  "BONELESS CHICKEN",
  "FRIED ONIONS",
  "DRIED POMEGRANATE SEEDS",
  "LEMON",
  "OKRA",
  "BITTER GOURD",
  "BOTTLE GOURD",
  "CURRY LEAF",
  "WHOLE RED CHILLI",
  "KALONJI",
  "BASMATI RICE",
  "STARANISE",
  "BLACK SALT",
  "PINK SALT",
  "WHITE PEPPER",
  "AJWAIN",
  "SAFFRON",
  "MUSTARD SEEDS",
  "JAGGERY",
  "NUTMEG",
  "MACE",
  "FENNEL SEEDS",
  "PANEER",
  "SPICY BEEF NOODLES",
  "PIZZA PASTA SAUCE",
  "CHICKEN POWDER",
  "PULAO SOUP STOCK",
  "CHATTPATTA NOODLES",
  "CHICKEN SOUP STOCK",
  "CHICKEN NOODLES",
  "SWEET THAI CHILLI SAUCE",
  "CHATTPATTA MASALA",
  "BLAZIN NOODLES",
  "CHICKEN LEG",
  "CHICKEN TENDERS",
  "CHICKEN THIGH",
  "CHICKEN WING",
  "CHICKPEAS",
  "CHILLI",
  "CIABATTA",
  "COCONUT MILK",
  "COD",
  "CORN",
  "CORN TORTILLAS",
  "CORNFLAKES",
  "CORNSTARCH",
  "COURGETTE",
  "CRAB",
  "CRABMEAT",
  "CREAM",
  "CREAM CHEESE",
  "CROUTONS",
  "CUCUMBER",
  "DATES",
  "DILL",
  "EDAMAME BEANS",
  "EGG",
  "FENNEL",
  "FETA CHEESE",
  "FETTUCCINE",
  "FOCACCIA",
  "GARLIC",
  "GEM LETTUCE",
  "GHEE",
  "GHERKIN",
  "GINGER",
  "GREEN BEANS",
  "GREEN PEAS",
  "GREEN PEPPER",
  "HABANERO",
  "HALIBUT",
  "HERRING",
  "HOTDOG",
  "ITALIAN HERBS",
  "JALAPENO",
  "JALAPENO PEPPER",
  "KALE",
  "KIDNEY BEANS",
  "KIMCHI",
  "KING PRAWN",
  "LAMB",
  "LEEKS",
  "LEMON GRASS",
  "LEMON WEDGES",
  "LENTILS",
  "LETTUCE",
  "LIME",
  "LOAF",
  "LUNCHEON MEAT",
  "MACARONI",
  "MACKEREL",
  "MAHI MAHI",
  "MAILLE MUSTARD",
  "MAYONNAISE",
  "MEATBALL",
  "MILK",
  "MINCED MEAT",
  "MINT",
  "MUSHROOM",
  "MUSTARD",
  "NAPA CABBAGE",
  "NOODLES",
  "NUTS",
  "OATMEAL",
  "OATS",
  "OLIVES",
  "ONION",
  "OREGANO",
  "PAPRIKA",
  "PARSLEY",
  "PARSNIP",
  "PASTA",
  "PASTRY",
  "PEANUT",
  "PEANUT BUTTER",
  "PEAS",
  "PEPPER",
  "PEPPERCORN",
  "PEPPERONI",
  "PEPPERS",
  "PICKLE",
  "PISTACHIO",
  "PITAS",
  "PIZZA DOUGH",
  "POTATO",
  "PRAWN",
  "QUINOA",
  "RADISH",
  "RAPESEED OIL",
  "RASPBERRY",
  "RED CHILLI",
  "RED CURRY PASTE",
  "RED KIDNEY BEANS",
  "RED PEPPER",
  "RICE",
  "ROSEMARY",
  "SALAD DRESSING",
  "SALMON",
  "SALMON FILLET",
  "SAUSAGE",
  "SHALLOT",
  "SHRIMP",
  "SOUR CREAM",
  "SOY SAUCE",
  "SOYBEAN",
  "SPAGHETTI",
  "SPINACH",
  "SPRING ONION",
  "SWEET POTATO",
  "TAHINI",
  "THAI BASIL",
  "THYME",
  "TOMATO",
  "TOMATO KETCHUP",
  "TOMATO PASTE",
  "TOMATO PUREE",
  "TOMATO SAUCE",
  "TORTILLAS",
  "TUNA",
  "TURKEY",
  "TURKEY BACON",
  "TURKEY BREAST",
  "TURKEY CUTLETS",
  "TURKEY WRAPS",
  "TURMERIC",
  "TURNIP",
  "VINEGAR",
  "WALNUTS",
  "WASABI",
  "WHEAT",
  "WHITE BEAN",
  "WHITE BREAD",
  "WHEAT FLOUR",
  "WHOLE WHEAT BREAD",
  "YOGHURT",
  "YOGURT",
  "ZUCCHINI",
  "SALSA",
  "RUSSET POTATO",
  "CUMIN",
  "DIJON MUSTARD",
  "RICOTTA CHEESE",
  "YELLOW BELL PEPPER",
  "RED BELL PEPPER",
  "CORN TOSTADA",
  "WHITE ONION",
  "RED CABBAGE",
  "BRUSSELS SPROUT",
  "YELLOW ONION",
  "SWEET CORN",
  "SHELL PASTA",
  "RED ONION",
  "ASIAN COLESLAW",
  "AUBERGINE",
  "CILANTRO",
  "POMEGRANATE",
  "PARATHA",
  "CROISSANT",
  "SAMOSA PATTI",
  "FILO PASTRY",
  "FENUGREEK LEAVES",
  "FENUGREEK",
  "KASURI METHI",
  "PARMESAN CHEESE",
  "PARMESAN CHEESE POWDER",
  "CHEESE POWDER",
  "OIL",
  "CORN OIL",
  "CANOLA OIL",
  "SUNFLOWER OIL",
  "VEGETABLE OIL",
  "PINK HIMALAYAN SALT",
  "POMEGRANATE MOLASSES",
  "ORANGE",
  "PAPAYA",
  "SUMAC",
  "TAJIN",
  "PICKLED CUCUMBER",
  "MIXED PICKLES",
  "MANGO PICKLES",
  "CRUSHED PICKLES",
  "HOT SAUCE",
  "COTTAGE CHEESE",
  "BUTTERMILK",
  "BREADCRUMBS",
  "SALAD LEAF",
  "PLUM",
  "DRIED PLUM"
];


export default lunchIngredients;